const tabifoto = {
  tabifoto: {
    nav: {
      home: "首頁",
      booking: "立即預訂",
      philosophy: "我們的故事",
      language: "語言",
      apply: "成為攝影師",
    },
    hero: {
      headline_1: "記錄你的旅途",
      headline_2: "在日本",
      subheadline: "與在地獨立攝影師合作，留下真實動人的影像故事",
      cta: "開始你的故事",
    },
    cities: {
      section_title: "選擇你的目的地",
      section_sub: "選擇城市，探索當地攝影師",
      kyoto: "京都",
      osaka: "大阪",
      tokyo: "東京",
      coming_soon: "即將開放",
    },
    storytelling: {
      label: "我們的理念",
      quote: "攝影不是關於地方，而是關於那些流逝的瞬間。",
      body: "我們相信每一段旅程都值得被誠實且美好地記錄。TaBiFoTo 連結您與深諳日本靈魂的在地獨立攝影師。",
    },
    services: {
      section_title: "我們的服務",
      section_sub: "純粹的攝影體驗 — 無捆綁，無附加",
      photography_8h: {
        title: "8小時攝影",
        desc: "全天與在地攝影師同行，捕捉您在城市中真實而珍貴的每一刻。",
        feature_1: "8小時專屬陪拍",
        feature_2: "100+ 張精修數位照片",
        feature_3: "私人線上相冊",
      },
      photography_video: {
        title: "攝影 + 短影片",
        desc: "包含所有攝影套餐內容，並加入電影質感的短片記錄。",
        feature_1: "含所有攝影套餐服務",
        feature_2: "60–90 秒電影風格短片",
        feature_3: "含配樂與調色",
      },
      from_price: "洽詢報價",
    },
    booking: {
      title: "預訂你的攝影體驗",
      step_1: "選擇城市",
      step_2: "選擇服務",
      step_3: "選擇日期",
      step_4: "加購選項",
      step_5: "確認預訂",
      select_city: "你的故事將在哪裡展開？",
      select_service: "選擇你的體驗方案",
      select_date: "你的特別日子是哪天？",
      select_addons: "選擇性加購",
      addons_note: "以下為外部合作夥伴服務，非 TaBiFoTo 提供",
      kimono_title: "和服租借",
      kimono_desc: "穿著傳統和服拍攝，由在地和服合作夥伴安排。",
      makeup_title: "髮型與妝容",
      makeup_desc: "拍攝前的專業造型服務，由在地美容合作夥伴安排。",
      external_partner: "外部合作夥伴",
      checkout_title: "確認你的預訂",
      your_name: "姓名",
      your_email: "電子郵件",
      your_phone: "聯絡電話",
      special_requests: "特殊需求（選填）",
      order_summary: "預訂摘要",
      city_label: "城市",
      service_label: "服務",
      date_label: "日期",
      addons_label: "加購項目",
      none: "無",
      confirm_booking: "確認預訂",
      booking_confirmed: "預訂請求已送出",
      booking_confirmed_desc: "我們已收到您的請求，團隊將在 24 小時內為您確認攝影師。",
      next: "繼續",
      back: "返回",
      select_date_placeholder: "選擇日期",
      morning: "上午",
      afternoon: "下午",
      full_day: "全天",
      legal_loading: "正在載入條款...",
      legal_section_title: "服務條款確認",
      legal_section_sub: "請閱讀並確認以下條款後繼續",
      legal_agree_prefix: "我同意",
      legal_version_prefix: "版本",
      legal_effective_prefix: "生效日期",
      legal_view_content: "閱讀條款",
      legal_hide_content: "收起",
      legal_required: "必填",
      legal_optional: "選填",
      legal_all_required_msg: "請勾選所有必填條款",
      legal_must_accept: "請勾選所有必填條款後才能完成預訂",
      field_required: "必填",
      field_email_invalid: "請輸入有效的電子郵件",
      photographer_preference_label: "拍攝舒適度偏好（選填）",
      photographer_preference_none: "無特別偏好",
      photographer_preference_female_preferred: "偏好女性攝影師",
      photographer_preference_note: "此偏好僅作為媒合參考，不作為限制接單條件。",
    },
    product: {
      photography_8h: "8小時攝影",
      photography_video: "攝影 + 短影片",
    },
    philosophy: {
      hero_title: "攝影，不是旅遊套餐",
      hero_sub: "我們的存在是為了連結人與真實的故事敘述者，而非銷售觀光行程。",
      section_1_title: "我們是誰",
      section_1_body: "TaBiFoTo 是一個預訂平台，連結旅人與日本各地的獨立攝影師。我們不是旅行社，不銷售行程、套裝商品，或包含交通與住宿的體驗包。",
      section_2_title: "獨立攝影師",
      section_2_body: "平台上的每位攝影師都是獨立承包人，擁有自己的創作視角、在地知識與專業技能。我們不雇用攝影師，我們放大他們的聲音。",
      section_3_title: "我們販售什麼",
      section_3_body: "我們販售與攝影師共度的時光。一項技能。一門藝術。誠實而美好地被保存。沒有追加銷售，沒有捆綁，沒有混淆你所得到的。",
      section_4_title: "瞬間，而非地標",
      section_4_body: "日本不缺乏標誌性景點。真正稀有的，是那個懂得在擁擠街道間尋找靜謐光線的人——而我們的攝影師正是如此。",
      values_title: "我們的價值觀",
      value_1_title: "真實性",
      value_1_body: "真實的攝影師，真實的瞬間，真實的回憶。",
      value_2_title: "獨立自主",
      value_2_body: "每位攝影師擁有自己的技藝與創作自由。",
      value_3_title: "簡單純粹",
      value_3_body: "一項服務。攝影。做到最好。",
      cta_title: "準備好創造回憶了嗎？",
      cta_body: "開始預訂，我們將為你媒合最適合的攝影師。",
      cta_button: "預訂攝影師",
    },
    footer: {
      tagline: "橫跨日本的真實攝影體驗",
      links_explore: "探索",
      link_home: "首頁",
      link_booking: "立即預訂",
      link_philosophy: "我們的故事",
      links_info: "資訊",
      link_faq: "常見問題",
      link_contact: "聯絡我們",
      link_terms: "使用條款",
      link_apply: "成為攝影師",
      newsletter_label: "持續獲得靈感",
      newsletter_placeholder: "你的電子郵件",
      newsletter_submit: "訂閱",
      copyright: "© 2024 TaBiFoTo. 版權所有。",
    },
    admin: {
      orders: "訂單管理",
      photographers: "攝影師管理",
      assignments: "指派管理",
    },
    apply: {
      page_title: "成為我們的攝影師",
      page_sub: "封測招募中 · 我們正在尋找日本各地的獨立攝影師夥伴",
      philosophy_title: "我們的合作理念",
      philosophy_body: "TaBiFoTo 不是旅遊平台，我們是攝影師與旅人之間的橋樑。我們尊重每位攝影師的創作自主性，提供媒合訂單、行程溝通與後台支援，讓你專注在最擅長的事：拍攝。",
      philosophy_point_1: "攝影師保有完整創作自由",
      philosophy_point_2: "平台處理預訂、溝通與行政",
      philosophy_point_3: "透明的分潤機制，無隱藏費用",
      requirements_title: "申請條件",
      req_language_title: "語言能力",
      req_language_body: "能以英文、中文或日文服務客戶（至少一種）。溝通能力比流利度更重要。",
      req_cities_title: "可服務城市",
      req_cities_body: "目前開放城市：京都、大阪、東京。未來將持續擴展。",
      req_portfolio_title: "作品集",
      req_portfolio_body: "需提供個人作品集連結（Instagram、個人網站、Behance 等均可）。作品風格無特定要求，真實、有溫度即可。",
      form_title: "申請表單",
      form_note: "封測期間申請資料將由團隊人工審核，通過後我們會主動聯繫。",
      field_name: "姓名",
      field_name_placeholder: "您的全名",
      field_email: "電子郵件",
      field_email_placeholder: "your@email.com",
      field_line_or_contact: "LINE / 其他聯絡方式",
      field_line_or_contact_placeholder: "LINE ID 或其他聯絡方式",
      field_service_cities: "可服務城市",
      field_languages: "可服務語言",
      field_portfolio_url: "作品集連結",
      field_portfolio_url_placeholder: "https://instagram.com/...",
      field_profile_image_url: "個人照片連結（選填）",
      field_profile_image_url_placeholder: "https://...",
      field_short_bio: "自我介紹",
      field_short_bio_placeholder: "簡短介紹你的攝影風格與經歷（200字以內）",
      city_kyoto: "京都",
      city_osaka: "大阪",
      city_tokyo: "東京",
      lang_zh: "中文",
      lang_en: "英文",
      lang_ja: "日文",
      submit: "送出申請",
      submitting: "送出中...",
      success_title: "已收到申請",
      success_body: "謝謝您的申請！平台將審核後聯繫您，請留意電子郵件。",
      error_required: "此欄位為必填",
      error_email: "請輸入有效的電子郵件",
      error_city: "請至少選擇一個城市",
      error_language: "請至少選擇一種語言",
      error_submit: "送出失敗，請稍後再試",
    },
  },
};

export default tabifoto;
